import DOMPurify from "dompurify";

const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    "a",
    "b",
    "blockquote",
    "br",
    "div",
    "em",
    "i",
    "li",
    "ol",
    "p",
    "strong",
    "u",
    "ul",
  ],
  ALLOWED_ATTR: ["href", "rel", "target"],
  FORBID_TAGS: ["span", "style", "script"],
  ALLOW_DATA_ATTR: false,
};

const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export const sanitizeRichText = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return DOMPurify.sanitize(value, RICH_TEXT_CONFIG).trim();
};

export const plainText = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    ALLOW_DATA_ATTR: false,
  }).trim();
};

export const getYouTubeVideoId = (value) => {
  if (typeof value !== "string" || !value.trim()) {
    return "";
  }

  try {
    const input = value.trim();
    const parsed = new URL(input.includes("://") ? input : `https://${input}`);
    const host = parsed.hostname.replace(/^www\./, "").replace(/^m\./, "");
    const parts = parsed.pathname.split("/").filter(Boolean);
    let candidate = "";

    if (host === "youtu.be") {
      candidate = parts[0] || "";
    } else if (["youtube.com", "music.youtube.com"].includes(host)) {
      if (parsed.pathname === "/watch") {
        candidate = parsed.searchParams.get("v") || "";
      } else if (["embed", "shorts", "live"].includes(parts[0])) {
        candidate = parts[1] || "";
      }
    }

    return YOUTUBE_ID_PATTERN.test(candidate) ? candidate : "";
  } catch {
    return "";
  }
};

export const getYouTubeEmbedUrl = (video) => {
  const videoId = video?.youtube_id || getYouTubeVideoId(video?.video_url);
  return YOUTUBE_ID_PATTERN.test(videoId)
    ? `https://www.youtube-nocookie.com/embed/${videoId}`
    : "";
};